// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__11snq","approved":"Status_approved__hpcqI","rejected":"Status_rejected__2btxb","expired":"Status_expired__1giWd","label":"Status_label__nvYfe"};